const StandardSpacer = () => {
  return <div className="w-full flex h-4" />;
};

export default StandardSpacer;
